import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "./logindesign.css";
import { useAuth } from './AuthContext';
import App from './App';
import LoginFailedModal from "./LoginFailedModal";
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaUser, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";


const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [clubCode, setClubCode] = useState('');
  const [clubId, setClubId] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  const [branchCode, setBranchCode] = useState('');
  const [branchId, setBranchId] = useState('');

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);

  const [branchCodeValidated, setBranchCodeValidated] = useState(false);
  const [clubName, setClubName] = useState('');
  const location = useLocation();
  const [branchName, setBranchName] = useState('');
  const handleClubValidation = async () => {
    try {
      if (!clubCode.trim()) {
        toast.error('Club code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });

      }

      if (clubCode.trim()) {

        const ClubData = {
          ClubCode: clubCode,
        };


        const response = await postLogin('ClubLoginApi', ClubData);

        if (response.responseCode === '1111') {
          setCompanyCodeValidated(true);
          setClubId(response.response_data.id)
          setClubName(response.response_data.name);
          setLoginFailed(false); // Reset loginFailed state
        } else {
          throw new Error(response.Message);
        }

      }

    } catch (error) {
      toast.error('Login failed', {
        position: 'top-center',
      });
    }
  };

  const handlebranchValidation = async () => {
    try {
      if (!branchCode.trim()) {
        toast.error('Branch code is required.', {
          position: toast.POSITION.TOP_CENTER,
        });

      }

      if (branchCode.trim()) {

        const BranchData = {
          BranchCode: branchCode,
        };


        const response = await postLogin('BranchLoginApi', BranchData);

        if (response.responseCode === '1111') {
          setBranchCodeValidated(true);
          setCompanyCodeValidated(true);
          setBranchId(response.response_data.id)
          setBranchName(response.response_data.name);
          setClubId(response.response_data.clubId)
          setClubName(response.response_data.clubName);
          setLoginFailed(false); // Reset loginFailed state
        } else {
          throw new Error(response.Message);
        }

      }

    } catch (error) {
      toast.error('Login failed', {
        position: 'top-center',
      });
    }
  };


  const handleLogin = async () => {
    try {
      if (!companyCodeValidated) {
        throw new Error('Club code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'clubId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      if (isSuper == false) {
        const parsedCompanyId = parseInt(responseData.clubId, 10);

        if (parsedCompanyId === clubId) {
          login(responseData.clubId, responseData.branchId,
            responseData.userId, isSuper, responseData.superAdminCompanyId,
            clubName, permissions, jwtToken, responseData.roleName, branchName, responseData.username);
          const redirectParam = new URLSearchParams(location.search).get("redirect");
          if (responseData.roleName === "SuperAdmin") {
            history.replace("/Home");
          }
          const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home1";
          history.replace(redirectPath);
        }
        else {
          toast.error('Invalid User !', {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      else {
        login(responseData.clubId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, clubName, permissions, jwtToken, responseData.roleName, branchName, responseData.username);
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home1";
        history.replace(redirectPath);
      }


    } catch (error) {
      toast.error('Login failed', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      clubId: clubId,
      branchId: branchId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const closeModal = () => {
    setLoginFailed(false);
  };

  if (isAuthenticated) {
    return <App />;
  }

  //   return (
  //     <div className="containers">
  //       <ToastContainer />
  //       <div className="login-boxs">
  //         <br />
  //         <h2 className="HEADING">LOGIN</h2>
  //         <br />

  //         {!branchCodeValidated && (
  //           <form onSubmit={(e) => {
  //             e.preventDefault();
  //             handlebranchValidation();
  //           }}>
  //             <div className="cc">
  //               <label>BRANCH CODE</label>
  //               <input
  //                 className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
  //                 type="text"
  //                 placeholder="Enter Branch code"
  //                 value={branchCode}
  //                 onChange={(e) => setBranchCode(e.target.value)}
  //               />
  //             </div>
  //             <br />
  //             <button className="lgn" type="submit">
  //               Let Me In
  //             </button>
  //           </form>
  //         )}


  //         {branchCodeValidated && (
  //           <div>
  //             <p className="welcome-message">Welcome to {clubName}</p>
  //             <br />
  //             <form onSubmit={(e) => {
  //               e.preventDefault();
  //               handleLogin();
  //             }}>




  //               <div className="em">
  //                 <label>USERNAME</label>
  //                 <input
  //                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
  //                   type="text"
  //                   placeholder="Enter username"
  //                   value={username}
  //                   onChange={(e) => setUsername(e.target.value)}
  //                   required
  //                 />
  //               </div>




  //               <div className="pwd">
  //                 <label>PASSWORD</label>
  //                 <input
  //                   className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
  //                   type="password"
  //                   placeholder="Password"
  //                   value={password}
  //                   onChange={(e) => setPassword(e.target.value)}
  //                   required
  //                 />
  //               </div>
  //               {/* <button className="lgn" type="submit">Login</button> */}
  //               <button className="lgn" type="submit" to={{
  //                 pathname: "/Home1",
  //                 state: { from: "/" },
  //               }}
  //                 onClick={() => {
  //                   localStorage.setItem('shouldReload', 'true');
  //                 }}>
  //                 Login
  //               </button>
  //             </form>
  //           </div>
  //         )}
  //       </div>

  //       {loginFailed && <LoginFailedModal onClose={closeModal} />}
  //     </div>
  //   );
  // };


  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#336D82",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}>
      <ToastContainer />
      <div style={{
        width: "100%",
        maxWidth: "400px",
        padding: "30px",
        borderRadius: "12px",
        background: "#336D82",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
        textAlign: "center",
      }}>
        <h2 className="text-2xl font-semibold text-white-800 text-center mb-6" style={{
          color: "#fff",
          fontFamily: 'JetBrains Mono',
        }}>
          LOGIN
        </h2>

        {!branchCodeValidated && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handlebranchValidation();
            }}
          >
            <div className="mb-4">
              <label className="block text-white font-medium mb-2" style={{ fontFamily: 'Oswald', fontWeight: 'bold' }}>
                BRANCH CODE
              </label>
              <input
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
                type="text"
                placeholder="Enter Branch code"
                value={branchCode}
                onChange={(e) => setBranchCode(e.target.value)}
                style={{
                  width: "100%",
                  padding: "10px 10px 10px 40px",
                  borderRadius: "8px",
                  border: "1px solid #4c6793",
                  background: "#4F959D",
                  color: "#fff",
                  outline: "none",
                  "::placeholder": {
                    color: "#fff",
                  },
                }}
              />
            </div>
            <button
              className="w-full bg-blue-500  py-2 rounded-md hover:bg-blue-600 transition"
              type="submit"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                borderRadius: "8px",
                border: "1px solid #fff",
                background: "transparent",
                color: "#fff",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.background = "#fff";
                e.target.style.color = "black";
              }}
              onMouseLeave={(e) => {
                e.target.style.background = "transparent";
                e.target.style.color = "#fff";
              }}
            >
              Let Me In
            </button>
          </form>
        )}

        {branchCodeValidated && (
          <div
            style={{
              width: "100%",
              maxWidth: "400px",
              padding: "30px",
              borderRadius: "12px",
              background: "#9ACBD0",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.5)",
              textAlign: "center",
            }}>
            <p className="text-center mb-6" style={{ fontFamily: 'Oswald', color: '#332D56' }} >
              Welcome to <span className="font-semibold" style={{ fontFamily: 'Oswald', fontSize: '18px', color: '#332D56' }}>{clubName}</span>
            </p>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleLogin();
              }}
            >
              {/* Username field with icon */}
              <div style={{ position: "relative", marginBottom: "15px" }}>
                <FaUser
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  type="text"
                  placeholder="User Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 10px 10px 40px",
                    borderRadius: "8px",
                    border: "1px solid #4c6793",
                    background: "#336D82",
                    color: "#fff",
                    outline: "none",
                  }}
                />
              </div>

              {/* Password field with icon and visibility toggle */}
              <div style={{ position: "relative", marginBottom: "15px" }}>
                <FaLock
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                  }}
                />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 10px 10px 40px",
                    borderRadius: "8px",
                    border: "1px solid #4c6793",
                    background: "#336D82",
                    color: "#fff",
                    outline: "none",
                  }}
                />
                <div
                  onClick={() => setShowPassword((prev) => !prev)}
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "10px",
                    transform: "translateY(-50%)",
                    color: "#ccc",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </div>
              </div>

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "10px",
                  marginTop: "15px",
                  borderRadius: "8px",
                  border: "1px solid #fff",
                  background: "transparent",
                  color: "#fff",
                  fontWeight: "bold",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#fff";
                  e.target.style.color = "#000";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.color = "#336D82";
                }}
              >
                Login
              </button>
            </form>

          </div>
        )}

        {loginFailed && <LoginFailedModal onClose={closeModal} />}
      </div>
    </div>
  );
}
export default LoginForm;

